module.exports = __webpack_public_path__ + "img/billing-logo.633fed16.png";